import { useRecoilValue } from 'recoil'
import { editorPagesAtom } from '@/atoms/_editorAtoms'
import {
  roleAtom,
  caseAtom,
  orderAtom,
  selectedProductsAtom,
  layoutAtom,
  userFuneralHomeAtom,
  caseFuneralHomeAtom,
  selectedThemeAtom,
  stylizedVersesAtom,
  itemsLockedAtom,
  editorOrderPageSetAtom,
  showPinturaAtom,
  showProductBleedAtom,
  insetRulerAtom,
  showRulerAtom,
} from 'atoms'

export type RecoilLogData = {
  role: unknown
  case: unknown
  order: unknown
  selectedProducts: unknown
  layout: unknown
  userFuneralHome: unknown
  caseFuneralHome: unknown
  selectedTheme: unknown
  stylizedVerses: unknown
  itemsLocked: unknown
  editorOrderPageSet: unknown
  editorPages: unknown
  showPintura: unknown
  showProductBleed: unknown
  insetRuler: unknown
  showRuler: unknown
}

export const useRecoilLogData = (): RecoilLogData => {
  return {
    role: useRecoilValue(roleAtom),
    case: useRecoilValue(caseAtom),
    order: useRecoilValue(orderAtom),
    selectedProducts: useRecoilValue(selectedProductsAtom),
    layout: useRecoilValue(layoutAtom),
    userFuneralHome: useRecoilValue(userFuneralHomeAtom),
    caseFuneralHome: useRecoilValue(caseFuneralHomeAtom),
    selectedTheme: useRecoilValue(selectedThemeAtom),
    stylizedVerses: useRecoilValue(stylizedVersesAtom),
    itemsLocked: useRecoilValue(itemsLockedAtom),
    editorOrderPageSet: useRecoilValue(editorOrderPageSetAtom),
    editorPages: useRecoilValue(editorPagesAtom),
    showPintura: useRecoilValue(showPinturaAtom),
    showProductBleed: useRecoilValue(showProductBleedAtom),
    insetRuler: useRecoilValue(insetRulerAtom),
    showRuler: useRecoilValue(showRulerAtom),
  }
}
